import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'

import { TimezonePicker } from 'components/timezone_picker'

import TimezoneSwitch from './timezone_switch'
import _Container from "timezone-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/timezone.js?styleId=Container";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp'),
    isPhone: useDeviceType('isPhone'),
    compactInline: false
  })
})

const Timezone = ({
  isFlatSpotpicker = false,
  variant = 'default',
  compactInline = false,
}) => (
  <Container isFlatSpotpicker={isFlatSpotpicker} compactInline={compactInline}>
    <TimezonePicker isFlatSpotpicker={isFlatSpotpicker} variant={variant} />
    <TimezoneSwitch />
  </Container>
)

export default Timezone
